import React from "react";
import Intro from "./components/Intro";
import HomeAboutVideo from "./components/HomeAboutVideo";
import Media from "./components/Media";
import About from "./components/About";
import Credits from "./components/Credits";
import NavBar from "./components/NavBar";
import BackgroundMusic from "./components/BackgroundMusic";
import RainOverlay from "./components/RainOverlay";
import "./App.css";
import "./styles/Global.css";
import "rsuite/dist/styles/rsuite-default.css";

function App() {
  return (
    <div className="App">
      <BackgroundMusic />
      <RainOverlay />
      <NavBar></NavBar>
      <div id="content">
        <Intro></Intro>
        <HomeAboutVideo />
        <About></About>
        <Media></Media>
        <Credits></Credits>
      </div>
    </div>
  );
}

export default App;
